<template>
  <el-table-column
    prop="type"
    sortable="custom"
    label="Típus"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <el-tag size="small" type="info" v-if="scope.row.type === 'measure'"><i class="el-icon-takeaway-box"></i> Disztribúciós felmérés</el-tag>
      <el-tag size="small" type="info" v-if="scope.row.type === 'photo'"><i class="el-icon-camera"></i> Képkészítés</el-tag>
      <el-tag size="small" type="info" v-if="scope.row.type === 'questionnaire'"><i class="el-icon-document-checked"></i> Kérdőív</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'type',
};
</script>
